export default __webpack_public_path__ + "static/media/product.e137b008.jpg";